<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-data-table
        :headers="headersArray"
        :pagination.sync="pagination"
        :items="documents"
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.type }}</td>
          <td v-if="manager">{{ props.item.user.name }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.number }}</td>
          <td width="1">{{ props.item.total | currency }}</td>
          <td>{{ props.item.proposal_date | moment("MMM D YYYY") }}</td>
          <td>{{ props.item.status }}</td>
          <td width="145">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon small class="ma-0" :to="getBuilderUrl(props.item)" v-on="on">
                  <fa-icon
                    :icon="props.item.type === 'Quote' ? 'pencil-alt' : 'eye'"
                    class="success--text"
                  />
                </v-btn>
              </template>
              <span>{{props.item.type === 'Quote' ? 'Edit' : 'View'}}</span>
            </v-tooltip>
            <v-tooltip top v-if="user.id === props.item.user_id">
              <template v-slot:activator="{ on }">
                <v-btn icon small class="ma-0" @click="duplicateDocument(props.item)" v-on="on">
                  <fa-icon icon="copy" />
                </v-btn>
              </template>
              <span>Duplicate</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon small class="ma-0" @click="deleteDocument(props.item)" v-on="on">
                  <fa-icon icon="times-circle" class="error--text" />
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>

      <div class="pagination pagination--table">
        <v-pagination v-model="pagination.page" :length="pages" v-if="pages > 1"></v-pagination>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Pagination from "@components/partials/Pagination";

var { documents } = require("@root/mixins");

export default {
  data: () => ({
    default_headers: [
      {
        text: "Type",
        align: "left",
        value: "type"
      },
      {
        text: "Rep",
        align: "left",
        value: "user_id"
      },
      {
        text: "Quote Name",
        align: "left",
        value: "name"
      },
      {
        text: "Estimate No.",
        align: "left",
        value: "number"
      },
      {
        text: "Amount",
        align: "left",
        value: "total"
      },
      {
        text: "Date Created",
        align: "left",
        value: "proposal_date"
      },
      {
        text: "Status",
        align: "left",
        value: "status"
      },
      {
        text: "Actions",
        align: "left",
        value: "actions",
        sortable: false
      }
    ],
    pagination: {
      rowsPerPage: 10,
      sortBy: "proposal_date",
      descending: true
    }
  }),

  mixins: [documents],

  components: { Pagination },

  props: {
    filters: {
      default: null
    },

    manager: {
      default: false
    }
  },

  computed: {
    ...mapGetters("documents", {
      GET_DOCUMENTS: "documents"
    }),

    ...mapGetters(["user", "searchQuery"]),

    headersArray() {
      let headers = this.default_headers;

      if (!this.manager) {
        _.remove(headers, header => {
          return header.value === "user_id";
        });
      }

      return headers;
    },

    documents() {
      let documents = this.GET_DOCUMENTS(
        "all",
        this.filters,
        this.displayQty,
        this.page,
        this.manager,
        this.searchQuery
      );

      if (documents === null) {
        return [];
      }

      return documents;
    },

    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(this.documents.length / this.pagination.rowsPerPage);
    }
  },

  methods: {
    ...mapActions("documents", {
      getDocuments: "getDocuments",
      DELETE_DOCUMENT: "deleteDocument",
      DUPLICATE_DOCUMENT: "createDuplicate"
    }),

    deleteDocument(document) {
      this.DELETE_DOCUMENT(document);
    },

    duplicateDocument(document) {
      this.DUPLICATE_DOCUMENT(document).then(data => {
        this.$router.push(this.getBuilderUrl(data.new_document));
      });
    }
  },

  created() {
    // TODO prevent request if documents already exist
    this.getDocuments({
      withSubordinates: this.manager,
      params: {
        manager: +this.manager,
        orderby: "proposal_date"
      }
    });
  }
};
</script>
